// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Yq-z","breadcrumbForward":"Zq-z","breadcrumbBack":"_q-z","selected":"ar-z"};